// extracted by mini-css-extract-plugin
export default {"loginBox":"login_layout_loginBox__Oh-Y8","loginContentWrapper":"login_layout_loginContentWrapper__g55KT"};